import type { IAppRegion } from '~/lib/appSettings';

export const getRegionFromPath = (path: string): IAppRegion | undefined =>
  path === 'dev-us' || path === 'preprod-fr' || path === 'us' || path === 'fr'
    ? `crowdaa-${path}`
    : undefined;
